/* Axtlan experience layer for the shop (owner order A7: as complex as axtlan.mx, sales focused; 2026-10-06).
 * 1. <ax-countdown data-until="midnight|week" data-tz-offset="-360">: live countdown to the next deal change
 *    (America/Merida = UTC-6, no DST). Weekly = next Wednesday 00:00, the rotation weeks start on Wednesday 2026-10-07.
 * 2. Experience mode (Complete / Light / Off) on <html data-ax-mode>, kept in localStorage 'axtlan-experience', starts
 *    Off for prefers-reduced-motion. It drives the holiday FX (event 'ax:mode') and the glyph effect.
 * 3. Soundtrack player [data-ax-player]: plays the axtlan.mx solar-signal tracks, never autoplays.
 * 4. Glyph reveal [data-ax-glyph]: letters start in the Axtlan Detector symbol font and resolve to Axtlan Soles,
 *    like axtlan.mx. Off in mode Off and under reduced motion. Text stays readable for screen readers (aria-label). */
(function () {
  'use strict';
  var root = document.documentElement;
  var KEY = 'axtlan-experience';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function getMode() {
    try { var v = localStorage.getItem(KEY); if (v === 'complete' || v === 'light' || v === 'off') return v; } catch (e) {}
    return reduced ? 'off' : 'complete';
  }
  function setMode(m) {
    try { localStorage.setItem(KEY, m); } catch (e) {}
    root.setAttribute('data-ax-mode', m);
    try { localStorage.setItem('axtlan-rotation-fx', m === 'complete' ? 'advanced' : m === 'light' ? 'lightweight' : 'off'); } catch (e) {}
    document.dispatchEvent(new CustomEvent('ax:mode', { detail: { mode: m } }));
    document.querySelectorAll('[data-ax-mode-set]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-ax-mode-set') === m));
    });
  }
  root.setAttribute('data-ax-mode', getMode());

  /* 2b. Experience panel preferences (axtlan.mx parity, 2026-10-07): theme, text size, contrast, readable typeface, link
     cues and color profile live in 'axtlan-experience-prefs' and on <html data-ax-*>; sections/axtlan-skin.liquid applies
     them before paint. Motion uses the mode above (complete = Full experience, light = Low usage, off = Reduce motion). */
  var PKEY = 'axtlan-experience-prefs';
  var lightMq = window.matchMedia && window.matchMedia('(prefers-color-scheme: light)');
  function getPrefs() { try { return JSON.parse(localStorage.getItem(PKEY) || '{}') || {}; } catch (e) { return {}; } }
  function applyPrefs(p) {
    var th = p.theme || 'dark';
    root.setAttribute('data-ax-theme-choice', th);
    root.setAttribute('data-ax-theme', th === 'system' ? (lightMq && lightMq.matches ? 'light' : 'dark') : th);
    root.setAttribute('data-ax-type', p.type || 'standard');
    root.setAttribute('data-ax-colour', p.colour || 'standard');
    if (p.contrast) root.setAttribute('data-ax-contrast', 'high'); else root.removeAttribute('data-ax-contrast');
    if (p.readable) root.setAttribute('data-ax-readable', 'true'); else root.removeAttribute('data-ax-readable');
    if (p.links) root.setAttribute('data-ax-links', 'true'); else root.removeAttribute('data-ax-links');
    document.dispatchEvent(new CustomEvent('ax:prefs', { detail: p }));
  }
  function setPref(name, value) { var p = getPrefs(); p[name] = value; try { localStorage.setItem(PKEY, JSON.stringify(p)); } catch (e) {} applyPrefs(p); }
  applyPrefs(getPrefs());
  if (lightMq && lightMq.addEventListener) lightMq.addEventListener('change', function () { applyPrefs(getPrefs()); });

  /* 1. countdown */
  function nextBoundary(kind, offsetMin) {
    var now = Date.now();
    var local = new Date(now + offsetMin * 60000); // shifted clock, read with UTC getters
    var t = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate() + 1);
    if (kind === 'week') {
      var dow = local.getUTCDay(); // 3 = Wednesday
      var add = (3 - dow + 7) % 7; if (add === 0) add = 7;
      t = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate() + add);
    }
    return t - offsetMin * 60000;
  }
  if (!customElements.get('ax-countdown')) {
    customElements.define('ax-countdown', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var off = parseInt(this.getAttribute('data-tz-offset') || '-360', 10);
        var kind = this.getAttribute('data-until') || 'midnight';
        var end = nextBoundary(kind, off);
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var tick = function () {
          var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
          if (s === 0) end = nextBoundary(kind, off);
          var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
          self.textContent = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(x);
        };
        tick(); this._t = setInterval(tick, 1000);
      }
      disconnectedCallback() { clearInterval(this._t); }
    });
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    /* 2. mode buttons */
    document.querySelectorAll('[data-ax-mode-set]').forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.getAttribute('data-ax-mode-set')); });
    });
    setMode(getMode());

    /* 2c. Experience panel: opener + <dialog>, five sections; every control writes through setPref / setMode */
    var dlg = document.querySelector('[data-ax-xp]'), opener = document.querySelector('[data-ax-xp-open]');
    var summary = document.querySelector('[data-ax-xp-summary]'), audioOn = false;
    function rt(n) { return dlg ? dlg.getAttribute('data-rt-' + n) || '' : ''; }
    function paintSummary() {
      if (!summary || !dlg) return;
      var p = getPrefs(), m = root.getAttribute('data-ax-mode'), c = p.colour || 'standard';
      summary.textContent = rt(root.getAttribute('data-ax-theme') === 'light' ? 'light' : 'dark') + ' · '
        + rt(m === 'complete' ? 'full' : m === 'light' ? 'low' : 'reduce') + (c !== 'standard' ? ' · ' + rt(c) : '')
        + ' · ' + rt(audioOn ? 'on' : 'off');
    }
    function syncInputs() {
      if (!dlg) return;
      var p = getPrefs(), vals = { 'ax-theme': p.theme || 'dark', 'ax-type': p.type || 'standard', 'ax-colour': p.colour || 'standard', 'ax-motion': getMode() };
      dlg.querySelectorAll('input[type=radio]').forEach(function (r) { r.checked = vals[r.name] === r.value; });
      dlg.querySelectorAll('input[type=checkbox]').forEach(function (c) { c.checked = !!p[c.name.slice(3)]; });
    }
    if (dlg && opener) {
      syncInputs(); paintSummary();
      opener.addEventListener('click', function () {
        syncInputs();
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        opener.setAttribute('aria-expanded', 'true');
      });
      dlg.addEventListener('close', function () { opener.setAttribute('aria-expanded', 'false'); opener.focus(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });   // click on the backdrop
      dlg.addEventListener('change', function (e) {
        var t = e.target, n = t.name;
        if (n === 'ax-motion') setMode(t.value);
        else if (t.type === 'checkbox') setPref(n.slice(3), t.checked);
        else if (n) setPref(n.slice(3), t.value);
        paintSummary();
      });
      var xpPlay = dlg.querySelector('[data-ax-xp-play]'), xpTrack = dlg.querySelector('[data-ax-xp-track]');
      if (xpPlay) xpPlay.addEventListener('click', function () { var b = document.querySelector('[data-ax-player] [data-ax-play]'); if (b) b.click(); });
      document.addEventListener('ax:audio', function (e) {
        audioOn = e.detail.on; paintSummary();
        if (xpPlay) { xpPlay.setAttribute('aria-pressed', String(audioOn)); xpPlay.textContent = e.detail.label; }
        if (xpTrack) xpTrack.textContent = e.detail.title;
      });
      document.addEventListener('ax:prefs', paintSummary);
    }

    /* 3. player */
    document.querySelectorAll('[data-ax-player]').forEach(function (p) {
      var tracks = JSON.parse(p.getAttribute('data-tracks') || '[]');
      if (!tracks.length) return;
      var audio = new Audio(); audio.preload = 'none'; var i = 0;
      var btn = p.querySelector('[data-ax-play]'), num = p.querySelector('[data-ax-num]'), title = p.querySelector('[data-ax-title]');
      var state = p.querySelector('[data-ax-state]');
      function load(n) {
        i = (n + tracks.length) % tracks.length; audio.src = tracks[i].src;
        if (num) num.textContent = (i < 9 ? '0' : '') + (i + 1) + ' / ' + (tracks.length < 10 ? '0' : '') + tracks.length;
        if (title) title.textContent = tracks[i].title;
      }
      function sync() {
        var on = !audio.paused;
        btn.setAttribute('aria-pressed', String(on));
        btn.setAttribute('aria-label', on ? p.getAttribute('data-l-pause') : p.getAttribute('data-l-play'));
        p.classList.toggle('is-playing', on);
        if (state) state.textContent = on ? p.getAttribute('data-l-playing') : p.getAttribute('data-l-paused');
        document.dispatchEvent(new CustomEvent('ax:audio', { detail: { on: on, title: tracks[i].title, label: on ? p.getAttribute('data-l-pause') : p.getAttribute('data-l-play') } }));
      }
      load(0); sync();
      btn.addEventListener('click', function () { if (audio.paused) audio.play().catch(function () {}); else audio.pause(); });
      p.querySelector('[data-ax-prev]').addEventListener('click', function () { var on = !audio.paused; load(i - 1); if (on) audio.play(); sync(); });
      p.querySelector('[data-ax-next]').addEventListener('click', function () { var on = !audio.paused; load(i + 1); if (on) audio.play(); sync(); });
      audio.addEventListener('play', sync); audio.addEventListener('pause', sync);
      // glow follows the music like axtlan.mx: an analyser sets --audio-energy/bass/mid/treble while playing
      audio.crossOrigin = 'anonymous'; var an = null, buf = null, raf = 0, rs = document.documentElement.style;
      var still = (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      function zero() { ['--audio-bass', '--audio-mid', '--audio-treble', '--audio-energy'].forEach(function (v) { rs.setProperty(v, '0'); }); }
      function tick() {
        if (!an || audio.paused) { raf = 0; zero(); return; }
        an.getByteFrequencyData(buf); var n = buf.length, s = [0, 0, 0];
        for (var k = 0; k < n; k++) s[k < n * .1 ? 0 : k < n * .45 ? 1 : 2] += buf[k];
        var b = s[0] / (n * .1 * 255), m = s[1] / (n * .35 * 255), t = s[2] / (n * .55 * 255), e = Math.min(1, (b * 1.2 + m + t * .8) / 2.2);
        rs.setProperty('--audio-bass', b.toFixed(3)); rs.setProperty('--audio-mid', m.toFixed(3)); rs.setProperty('--audio-treble', t.toFixed(3)); rs.setProperty('--audio-energy', e.toFixed(3));
        raf = requestAnimationFrame(tick);
      }
      audio.addEventListener('play', function () {
        if (still || document.documentElement.getAttribute('data-ax-mode') === 'off') return;
        try {
          if (!an) { var C = window.AudioContext || window.webkitAudioContext, ctx = new C(), src = ctx.createMediaElementSource(audio);
            an = ctx.createAnalyser(); an.fftSize = 256; buf = new Uint8Array(an.frequencyBinCount); src.connect(an); an.connect(ctx.destination); audio.axCtx = ctx; }
          if (audio.axCtx.state === 'suspended') audio.axCtx.resume();
          if (!raf) raf = requestAnimationFrame(tick);
        } catch (err) { an = null; }
      });
      audio.addEventListener('ended', function () { load(i + 1); audio.play(); });
    });

    /* 5. listen / view / share menu: addresses are fetched only when a visitor opens it (not in the page HTML) */
    document.querySelectorAll('[data-ax-share]').forEach(function (d) {
      var loaded = false;
      function fill(data) {
        var kind = d.getAttribute('data-kind'), key = d.getAttribute('data-key'), handle = d.getAttribute('data-handle');
        var pr = data.profiles || {};
        var map = kind === 'album'
          ? { album: (data.albums || {})[handle] || pr.distrokid, spotify: pr.spotify, applemusic: pr.applemusic, amazonmusic: pr.amazonmusic, tidal: pr.tidal, youtube: pr.youtube }
          : { print: (data.prints || {})[key], artstation: pr.artstation, prints: pr.prints };
        d.querySelectorAll('[data-ax-link]').forEach(function (a) {
          var u = map[a.getAttribute('data-ax-link')];
          if (u) a.href = u; else a.parentNode.hidden = true;
        });
        var url = d.getAttribute('data-url'), title = d.getAttribute('data-title');
        var img = (document.querySelector('meta[property="og:image"]') || {}).content || '';
        var share = {
          facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
          pinterest: 'https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) + '&media=' + encodeURIComponent(img) + '&description=' + encodeURIComponent(title),
          x: 'https://x.com/intent/post?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title)
        };
        d.querySelectorAll('[data-ax-share-to]').forEach(function (a) { a.href = share[a.getAttribute('data-ax-share-to')]; });
        var nat = d.querySelector('[data-ax-share-do="native"]');
        if (navigator.share && nat) { nat.hidden = false; nat.addEventListener('click', function () { navigator.share({ title: title, url: url }).catch(function () {}); }); }
        var cp = d.querySelector('[data-ax-share-do="copy"]');
        if (cp) cp.addEventListener('click', function () {
          (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () { cp.textContent = d.getAttribute('data-copied'); }).catch(function () {});
        });
      }
      d.addEventListener('toggle', function () {
        if (!d.open || loaded) return; loaded = true;
        fetch(d.getAttribute('data-src')).then(function (r) { return r.json(); }).then(fill).catch(function () { loaded = false; });
      });
    });

    /* 4. glyph reveal */
    var glyphs = document.querySelectorAll('[data-ax-glyph]');
    if (!glyphs.length || root.getAttribute('data-ax-mode') === 'off' || reduced) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); reveal(e.target); } });
    }, { threshold: .4 }) : null;
    function reveal(el) {
      var text = el.textContent; if (!text.trim() || el.dataset.axDone) return; el.dataset.axDone = '1';
      el.setAttribute('aria-label', text.trim());
      var spans = [];
      el.textContent = '';
      for (var k = 0; k < text.length; k++) {
        var s = document.createElement('span'); s.textContent = text[k]; s.setAttribute('aria-hidden', 'true');
        if (text[k] !== ' ') { s.className = 'ax-glyph-char'; spans.push(s); }
        el.appendChild(s);
      }
      var light = root.getAttribute('data-ax-mode') === 'light';
      spans.forEach(function (s, n) {
        setTimeout(function () { s.className = ''; }, (light ? 250 : 450) + n * (light ? 25 : 55) + Math.random() * (light ? 150 : 400));
      });
    }
    glyphs.forEach(function (g) { if (io) io.observe(g); else reveal(g); });
  });
})();

/* share line: copy link + the phone's own share sheet; YouTube subscriber count widget loaded after the page */
(function () {
  function ready(f) { if (document.readyState !== 'loading') f(); else document.addEventListener('DOMContentLoaded', f); }
  ready(function () {
    document.querySelectorAll('[data-ax-share-line]').forEach(function (b) {
      var url = location.href.split('#')[0], st = b.querySelector('[data-ax-copy-status]');
      var nat = b.querySelector('[data-ax-native-share]');
      if (nat && navigator.share) { nat.hidden = false; nat.addEventListener('click', function () { navigator.share({ title: document.title, url: url }).catch(function () {}); }); }
      var cp = b.querySelector('[data-ax-copy-link]');
      if (cp) cp.addEventListener('click', function () {
        (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
          if (st) st.textContent = cp.getAttribute('data-done'); setTimeout(function () { if (st) st.textContent = ''; }, 2500);
        }).catch(function () { window.prompt('', url); });
      });
    });
    var yc = document.querySelector('[data-ax-ytcount]');
    if (yc) {
      var go = function () {
        var d = document.createElement('div'); d.className = 'g-ytsubscribe'; d.setAttribute('data-channelid', yc.getAttribute('data-channel'));
        d.setAttribute('data-layout', 'default'); d.setAttribute('data-count', 'default'); d.setAttribute('data-theme', 'dark'); yc.appendChild(d);
        var s = document.createElement('script'); s.src = 'https://apis.google.com/js/platform.js'; s.async = true; document.head.appendChild(s);
      };
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 3000 }); else setTimeout(go, 1500);
    }
  });
})();
